const mobileHallDetail = {
  mobileBusiness: {
    noTitleType: true,
    title: "移动营业厅",
    image: "./images/mobileBusiness1.png",
    tips:
      "移动营业厅是客户服务渠道，是下一代的手机银行，是客户与银行接触的主要渠道，能为客户提供像在物理网点一样的、有互动的、温馨的金融和商业服务。区别于传统手机银行的自助式服务，移动营业厅主打和客户主动互动、提供温馨服务的模式，为金融机构带来组织上、产品形态上，服务体系上的变革。",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "独立的“云端分行”",
        icon: "./images/business1.png",
        tips: "组织架构敏捷且互联网化为客户提供端到端的全方位、全业务、全场景的服务 "
      },
      {
        title: "在AI语音服务",
        icon: "./images/business2.png",
        tips: "主打“听得懂，办得了”，如一句话转账功能"
      },
      {
        title: "虚拟员工服务",
        icon: "./images/business3.png",
        tips: "依照3D真人打造金融机构自有的虚拟形象，为客户提供金融服务"
      },
      {
        title: "专属金融产品",
        icon: "./images/business4.png",
        tips: "以互联网的高效节奏，向用户推出定制化金融产品"
      }
    ]
  },
  mobileWorkstation: {
    noTitleType: true,
    title: "移动工作站",
    image: "./images/mobileBusiness.png",
    tips:
      "移动工作站是员工服务渠道产品，让客户经理可以离开物理网点，像送外卖一样，将金融服务送到客户手中。其中主要包括移动获客、移动营销、移动审批等场景应用，是客户经理提供一站式服务的生产力工具。",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "\"坐商\"变\"行商\"",
        icon: "./images/workstation1.png",
        tips: "客户经理走出网点，有能力主动面对面接触客户"
      },
      {
        title: "在场景中服务业务",
        icon: "./images/workstation2.png",
        tips: "通过\"前台、中台、后台\"把各岗位串联起来，提供完整的服务解决方案"
      },
      {
        title: "提高业务效率",
        icon: "./images/workstation3.png",
        tips: "最快54秒完成开户及综合签约"
      },
      {
        title: "提高管理效率",
        icon: "./images/workstation4.png",
        tips: "业务审批、业务授权，随时随地办公"
      }
    ]
  }
};
export default mobileHallDetail;
